export const SNAP_LENS_GROUP_ID = "ef0710f5-81af-49c2-ada4-37ce1e739a7b";

/** @typedef {{ id: string, name: string, lensId: string, lensGroupId: string, iconImage?: string, themeColor?: string, hidden?: boolean }} SnapFilterDefinition */

/** @type {SnapFilterDefinition[]} */
export const SNAP_FILTERS = [
  {
    id: "no_filter",
    name: "بدون فلتر",
    lensId: "",
    lensGroupId: "",
    iconImage: "/filters/no-filter.webp",
    themeColor: "#2b2b2b",
  },
  {
    id: "snow_radiance",
    name: "فلتر 1 - شديد البياض",
    lensId: "8bb3fce5-ad1f-4e5b-a68e-4a7906ac0771",
    lensGroupId: SNAP_LENS_GROUP_ID,
    iconImage: "/filters/snow-radiance.webp",
    themeColor: "#b879ff",
  },
  {
    id: "glow_whitening",
    name: "فلتر 2 - بياض وتوهج",
    lensId: "c74a0377-5951-4230-a69d-7b384d1b6cf4",
    lensGroupId: SNAP_LENS_GROUP_ID,
    iconImage: "/filters/glow-whitening.webp",
    themeColor: "#f5b6d2",
    // Hidden for MVP: keeping only one of snow_radiance/glow_whitening
    // visible (snow_radiance's icon asset is lighter). Not deleted: lens/
    // config stay intact in case it's needed later.
    hidden: true,
  },
  {
    id: "cartoon_camera",
    name: "فلتر 3 - شخصية كرتونية",
    lensId: "0aeeb40c-5165-425f-b05b-24bde9f39a1b",
    lensGroupId: SNAP_LENS_GROUP_ID,
    iconImage: "/filters/cartoon-camera.webp",
    themeColor: "#8a4dff",
    // Hidden from the MVP filter bar (heavy AR lens, not needed for MVP).
    // Not deleted: lens/config stay intact in case it's needed later.
    hidden: true,
  },
  {
    id: "luminous_femme",
    name: "فلتر 4 - تنعيم طبيعي",
    lensId: "60f7ecb1-386b-406d-9053-51603a96cd59",
    lensGroupId: SNAP_LENS_GROUP_ID,
    iconImage: "/filters/luminous-femme.webp",
    themeColor: "#ffb36b",
  },
];

/** Filters shown in the MVP filter bar (excludes hidden/heavy lenses). */
/** @type {SnapFilterDefinition[]} */
export const SNAP_FILTERS_VISIBLE = SNAP_FILTERS.filter((filter) => !filter.hidden);

export const SNAP_FRONT_CAMERA_SOURCE = {
  kind: "camera",
  options: {
    cameraFacing: "user",
    outputSize: { mode: "match-input" },
  },
};

/**
 * @param {string} id
 * @returns {SnapFilterDefinition | undefined}
 */
export function getSnapFilterById(id) {
  return SNAP_FILTERS.find((filter) => filter.id === id);
}

/**
 * @param {SnapFilterDefinition} filter
 * @returns {boolean}
 */
export function hasActiveSnapLens(filter) {
  return Boolean(filter.lensId && filter.lensGroupId);
}
